import { formatParsedDate, parseDate } from './date';
import { DEFAULT_MOBILE_DATE_FORMAT } from './defaultValues';

export const getDisplayValue = (date, locale = 'uk') =>
  formatParsedDate(date, 'DD.MM.YYYY', locale);

export const toNativeDateValue = date => {
  const parsedDate = parseDate(date);

  return parsedDate ? parsedDate.format(DEFAULT_MOBILE_DATE_FORMAT) : '';
};

export const getDisplayValueForCharts = getDisplayValue;
